/**
 * Report a caught error to Elastic APM
 *
 * @param err Error to report
 */
export function reportError(err: Error) {
  if (typeof window !== 'undefined' && window?.apm && window.apm.isActive()) {
    window.apm.captureError(err);
  }
}

/**
 * Report a message to Elastic APM
 * This function is handy if something went wrong,
 * but an Error did not happen.
 *
 * @param message message to report
 */
export function reportMessage(message: string, level: 'error' | 'warning' | 'info' = 'error') {
  // Current Elastic APM only support captureError, does not support normal message being logged.
  if (typeof window !== 'undefined' && window?.apm && window.apm.isActive() && level === 'error') {
    window.apm.captureError(new Error(message));
  }
}
